import { useState } from 'react';
import { AndroidLogo, AppleLogo, DeviceMobile } from '@phosphor-icons/react';
import Modal from '../../../shared/components/Modal';
import InstallSteps from './Parts/InstallSteps';

type InstallAppModalProps = { onClose: () => void; t: any };

const preferredPlatform = () => (
  /iPad|iPhone|iPod/.test(navigator.userAgent) ? 'ios' : 'android'
);

export default function InstallAppModal({ onClose, t }: InstallAppModalProps) {
  const [platform, setPlatform] = useState(preferredPlatform);
  const steps = platform === 'ios'
    ? [t.installIosStep1, t.installIosStep2, t.installIosStep3, t.installIosStep4]
    : [t.installAndroidStep1, t.installAndroidStep2, t.installAndroidStep3, t.installAndroidStep4];

  return (
    <Modal onClose={onClose} label={t.getTheApp}>
      <div className="install-app-modal">
        <div className="install-app-heading">
          <span><DeviceMobile weight="fill" /></span>
          <div>
            <span className="eyebrow coral">{t.installAppEyebrow}</span>
            <h2>{t.getTheApp}</h2>
            <p>{t.installAppSubtitle}</p>
          </div>
        </div>
        <div className="install-platform-tabs" role="tablist" aria-label={t.chooseDevice}>
          <button type="button" className={platform === 'ios' ? 'active' : ''} onClick={() => setPlatform('ios')} role="tab" aria-selected={platform === 'ios'}>
            <AppleLogo weight="fill" />iPhone &amp; iPad
          </button>
          <button type="button" className={platform === 'android' ? 'active' : ''} onClick={() => setPlatform('android')} role="tab" aria-selected={platform === 'android'}>
            <AndroidLogo weight="fill" />Android
          </button>
        </div>
        <InstallSteps steps={steps} />
        <p className="install-app-note">{t.installAppNote}</p>
        <button type="button" className="primary full" onClick={onClose}>{t.gotIt}</button>
      </div>
    </Modal>
  );
}
